import { getIndexes } from "common/utils";

export const parsePolicyNames = (response, bqnId) => {
  const lines = response.trim("\n").split("\n");
  const [_head, ...rows] = lines;
  const headAttrs = _head.trim("\n").split(/\s+/);
  const nameIndex = headAttrs.indexOf('NAME');
  const bqnIndex = headAttrs.indexOf('BQN');
  const names = [];

  for(let row of rows){
    const values = row.trim().split(/\s+/);
    if(bqnId === 'all' || values[bqnIndex] === bqnId.toString()){
      names.push(values[nameIndex])
    }
  }
  return names;
};
const allFields = [
  "BQN",
  "ADDRESS",
  "SUBSCRIBER-ID",
  "USER-NAME",
  "CALL-STATION-ID",
  "NAS-IDENTIFIER",
  "NAS-IP-ADDRESS",
  "NAS-PORT",
  "ACCT-SESS-ID",
  "BLOCK",
  "POLICY",
  "P-ASSIGN",
  "QUOTA",
  "LIMIT-TIME",
  "LIMIT-VOLUME",
  "CREATED",
  "UPDATED",
  "SUBS-GROUPS",
  "ACTIVE",
  "UNDEFINED"
]

const attrRelevantFields = [
  "SUBSCRIBER-ID",
  "BLOCK",
  "POLICY",
  "P-ASSIGN",
  "QUOTA",
  "SUBS-GROUPS",
  "UNDEFINED"
]

const areEntriesEquivalent = (one, other, relevantFields = allFields) =>
  one === other ||
  relevantFields.every( field => one[field] === other[field]);

export const aggregateIpAddresses = (response, nBqns, relevantFields = attrRelevantFields) => {
  const [head, ...rows] = response.trim().split("\n");
  const headerIndexes = getIndexes(head);

  const ipAddresses = {};
  for (const row of rows) {
    const attrs = row.trim().split(/\s+/);
    const entry = {}
    for (const field of allFields) {
      entry[field] = attrs[headerIndexes[field]]
    }
    const address = entry["ADDRESS"];
    (ipAddresses[address] = ipAddresses[address] || []).push(entry);
  }
  let output = `${head}\n`;
  const skipIpAddress = new Set();

  for (const row of rows) {
    const attrs = row.trim().split(/\s+/);
    const ipAddress = attrs[headerIndexes["ADDRESS"]];

    if(skipIpAddress.has(ipAddress)){
      continue;
    }

    const entries = ipAddresses[ipAddress];

    if (entries.length <= 1 || entries.length !== nBqns) {
      output += `${row}\n`;
      continue;
    }

    let presentInAllBqns = true;
    const activeBqn = [];
    const first = entries[0];
    for (const entry of entries) {
      if (entry['ACTIVE'] !== "no") {
        activeBqn.push(entry['BQN']);
      }

      if ( areEntriesEquivalent(entry, first, relevantFields) !== true ) {
        presentInAllBqns = false;
        break;
      }
    }

    if (presentInAllBqns === true) {
      skipIpAddress.add(ipAddress);
      first['BQN'] = "All";
      first['ACTIVE'] =
        activeBqn.length === 0
          ? "no"
          : activeBqn.length === 1
          ? `yes-(${activeBqn[0]})`
          : activeBqn.length === nBqns
          ? "yes-(all)"
          : `yes`;
      const newRow = allFields.map(field => first[field]);
      output += newRow.join(" ") + "\n";
    } else {
      output += `${row}\n`; 
    }
  }

  return output;
};
